import * as React from 'react';

export const usFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_273)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_273'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_273)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0H12V9.33333H0V0Z'
                    fill='#001A5B'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M12 0V1.33333H28V0H12ZM12 2.66667V4H28V2.66667H12ZM12 5.33333V6.66667H28V5.33333H12ZM12 8V9.33333H28V8H12ZM0 10.6667V12H28V10.6667H0ZM0 13.3333V14.6667H28V13.3333H0ZM0 16V17.3333H28V16H0ZM0 18.6667V20H28V18.6667H0Z'
                    fill='#C0032C'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M1.33334 1.33333V2.66666H2.66668V1.33333H1.33334ZM4.00001 1.33333V2.66666H5.33334V1.33333H4.00001ZM6.66668 1.33333V2.66666H8.00001V1.33333H6.66668ZM9.33334 1.33333V2.66666H10.6667V1.33333H9.33334ZM8.00001 2.66666V3.99999H9.33334V2.66666H8.00001ZM5.33334 2.66666V3.99999H6.66668V2.66666H5.33334ZM2.66668 2.66666V3.99999H4.00001V2.66666H2.66668ZM1.33334 3.99999V5.33333H2.66668V3.99999H1.33334ZM4.00001 3.99999V5.33333H5.33334V3.99999H4.00001ZM6.66668 3.99999V5.33333H8.00001V3.99999H6.66668ZM9.33334 3.99999V5.33333H10.6667V3.99999H9.33334ZM1.33334 6.66666V7.99999H2.66668V6.66666H1.33334ZM4.00001 6.66666V7.99999H5.33334V6.66666H4.00001ZM6.66668 6.66666V7.99999H8.00001V6.66666H6.66668ZM9.33334 6.66666V7.99999H10.6667V6.66666H9.33334ZM8.00001 5.33333V6.66666H9.33334V5.33333H8.00001ZM5.33334 5.33333V6.66666H6.66668V5.33333H5.33334ZM2.66668 5.33333V6.66666H4.00001V5.33333H2.66668Z'
                    fill='#F1F5F9'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_273'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
